import {
    FETCH_APPS_FAILURE,
    FETCH_APPS_REQUEST,
    FETCH_APPS_SUCCESS,
} from './types/apps-action-types';
import DspService from '../services/dsp-service';

function fetchAppsRequest(){
    return {
        type: FETCH_APPS_REQUEST
    };
}
function fetchAppsSuccess( response ){
    return {
        apps: response.data,
        type: FETCH_APPS_SUCCESS,
    };
}
function fetchAppsFailure( error ){
    return {
        error: error.response,
        type: FETCH_APPS_FAILURE,
    };
}

export function fetchApps(){
    return ( dispatch, getState, { DSP_API } ) => {
        dispatch( fetchAppsRequest() );
        const api = new DspService( DSP_API );

        return api.getApprovedApps().then(
            ( response ) => {
                dispatch( fetchAppsSuccess( response ) );
            },
            ( error ) => dispatch( fetchAppsFailure( error ) )
        );
    };
}
